import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currentCard", "changeForm"]
  
  showForm() {
    this.currentCardTarget.classList.add("hidden")
    this.changeFormTarget.classList.remove("hidden")
  }
  
  hideForm() {
    this.currentCardTarget.classList.remove("hidden")
    this.changeFormTarget.classList.add("hidden")
  }
}